import { useEffect } from 'react';
import { useCancelPromise } from '@Utilities/services/hooks/useCancelPromise';

export default function useButton({ onSuccess, isSuccess }) {
  const cancelPromise = useCancelPromise();

  useEffect(() => {
    let timerId = null;
    if (onSuccess && isSuccess) {
      timerId = setTimeout(() => {
        if (!cancelPromise.current) onSuccess();
        timerId = null;
      }, 500);
    }
    return () => clearTimeout(null);
  }, [isSuccess]);
}
